import { CirclePlus, Receipt, Trash, Users, UsersRound, WalletCards, Weight } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, convertThreeDecimalsWithoutZero, convertToNumber, convertTwoDecimalsOnValue, getDateAndTime, handleDateChange, sanitizeInput } from "../CommonComponents/CustomHooks";
import { CommonApiData, virtualPath } from "../CommonComponents/EnvConfig";
import { AutoCompleteBoxNew, AutoCompleteBoxNumeric, DateBox, FormButton, InputBox, SelectInputBox, Switch } from "../CommonComponents/InputBox";


const Shipment = () => {
    const inputrefs = useRef({})
    const dispatch = useDispatch()
    const isAdvanceLayout = false;
    const loginUserClientCode = CommonApiData().loginUserClientCode;
    const [validateFeild, setValidateFeild] = useState({
        buisnessType: "",
        volumetricSelection: ""
    })
    const initialFormData = {
        isMannualAwbNo: false,
        isUpdateAwbNo: false,
        awbNo: "",
        pickupRequestNo:"",
        refNo: "",
        pickupDate: getDateAndTime().date,
        salesPerson: "",
        pickupPoint: "",
        bookingType: "Forward",
        buisnessType: "",
        serviceMode: "",
        volumetricSelection: "",

        isConsignorSave: false,
        consignorName: "",
        consignorCompanyName: "",
        consignorPinCode: "",
        consignorCity: "",
        consignorState: "",
        consignorAddress1: "",
        consignorAddress2: "",
        consignorAddress3: "",
        consignorMobileNo: "",
        consignorEmailID: "",
        consignorGSTNO: "",
        consignorAadharNo: "",

        isConsigneeSave: false,
        consigneeName: "",
        consigneeCompanyName: "",
        consigneePinCode: "",
        consigneeCity: "",
        consigneeState: "",
        consigneeAddress1: "",
        consigneeAddress2: "",
        consigneeAddress3: "",
        consigneeMobileNo: "",
        consigneeEmailID: "",
        consigneeGstNo: "",
        consigneeAadharNo: "",

        deliveryType: "DoorDelivery",
        expectedDeliveryDate: "",
        destinationBranch: "",

        isInsurance: false,
        insuranceValue: "",
        isVolWeight: false,

        totalPcs: "",
        actualWeight: "",
        totalWeight: "",
        totalChargeWeight: "",
        totalVolumetricWeight: "",

        packetDescription: "",

        weightDetails: [{
            partNo: "",
            pcs: "",
            itemCode: "",
            boxNo: "System Generated",
            weight: "",
            boxDescription: "",
            length: "",
            width: "",
            height: "",
            volumetricWeight: ""
        }],
        invoiceDetails: [],
        paymentType: "",
        amount: "",
        packetType: "",
        serviceType: "",
        shipmentType: "",
        codAmount: "",
        remarks: "",
        pageType: "PickUp Entry",
        divisor: '',
        cft: '',
        isVolSelection: false,
        loadType: "PTL",
    };

    const [formData, setFormData] = useState(initialFormData);
    const loginData = CommonApiData();
    const [awbNoForPrint, setawbNoForPrint] = useState('')
    const isPcsMultiply = loginData?.isPcsMultiply;
    const GetPickupPoint = DropDownData('GetPickupPoint', loginUserClientCode)
    const getBookingType = DropDownData('GetPacketBookingType')
    const GetBuisnessType = DropDownData('GetBuisnessType')
    const GetServiceMode = DropDownData('GetServiceMode')
    const getVolumertricSelection = DropDownData('GetVolumetricSelection')
    const GetPacketType = DropDownData('GetPacketType')
    const GetServiceType = DropDownData('GetServiceTypeCode', formData.serviceMode)
    const GetPaymentType = DropDownData('GetPaymentType')
    const GetShipmentType = DropDownData('GetShipmentType')
    const getLoadType = DropDownData('GetLoadType')
    const [ispayment, setIspayment] = useState(false);
    const handleClear = () => {
        setFormData(initialFormData);
        handleClearInvoice()
        inputrefs.current['txtPickupRequestNo'].focus()
    }

    const handleRowChange = (index, field, value) => {
        const updatedRows = [...formData.weightDetails];
        updatedRows[index][field] = value;
        const length = parseFloat(updatedRows[index].length) || 0;
        const width = parseFloat(updatedRows[index].width) || 0;
        const height = parseFloat(updatedRows[index].height) || 0;
        const divisor = parseFloat(formData.divisor) || 5000;
        const cft = parseFloat(formData?.cft) || 1;
        const volumetricSelection = formData?.volumetricSelection
        const pcs = parseFloat(updatedRows[index].pcs) || 1;

        if (length && width && height && divisor) {
            const isInch = volumetricSelection?.toUpperCase() === 'INCH';
            let baseVolume = length * width * height;
            if (isInch && cft) {
                baseVolume *= cft;
            }
            if (isPcsMultiply && pcs) {
                baseVolume *= pcs;
            }
            const volWeight = baseVolume / divisor;
            updatedRows[index].volumetricWeight = Number(volWeight).toFixed(3);
        } else {
            updatedRows[index].volumetricWeight = "";
        }

        let updatedForm = {
            ...formData,
            weightDetails: updatedRows
        };

        if (field === "boxDescription") {

            const allDescriptions = updatedRows
                .map(r => r.boxDescription)
                .filter(Boolean);

            updatedForm.packetDescription = [...new Set(allDescriptions)].join(", ");
        }
        setFormData(updatedForm)
    };

    const handleDeleteRow = (index) => {
        const updated = formData.weightDetails.filter((_, i) => i !== index);
        const allDescriptions = updated
            .map(r => r.boxDescription)
            .filter(Boolean)

        setFormData({
            ...formData,
            weightDetails: updated,
            packetDescription: [...new Set(allDescriptions)].join(", ")
        });
    };

    const handleAddRows = () => {
        setFormData(prev => {
            const rows = prev.weightDetails;
            const lastIndex = rows.length - 1;
            const lastRow = rows[lastIndex];


            if (!lastRow.pcs) {
                inputrefs.current[`pcs_${lastIndex}`]?.focus();
                NotificationSound("warning", "Please enter Pieces!");
                return prev;
            }

            if (!lastRow.weight) {
                inputrefs.current[`weight_${lastIndex}`]?.focus();
                NotificationSound("warning", "Please enter Weight!");
                return prev;
            }

            if (prev.isVolWeight) {
                if (!lastRow.length) {
                    inputrefs.current[`length_${lastIndex}`]?.focus();
                    NotificationSound("warning", "Please enter Length!");
                    return prev;
                }
                if (!lastRow.width) {
                    inputrefs.current[`width_${lastIndex}`]?.focus();
                    NotificationSound("warning", "Please enter Width!");
                    return prev;
                }
                if (!lastRow.height) {
                    inputrefs.current[`height_${lastIndex}`]?.focus();
                    NotificationSound("warning", "Please enter Height!");
                    return prev;
                }
            }

            if (!lastRow.boxDescription) {
                inputrefs.current[`BoxDescription_${lastIndex}`]?.focus();
                NotificationSound("warning", "Please enter Description!");
                return prev;
            }


            const totalEnteredPcs = rows.reduce((sum, r) => {
                return sum + (parseInt(r.pcs) || 0);
            }, 0);

            if (totalEnteredPcs >= (parseInt(prev.totalPcs) || 0)) {
                inputrefs.current[`pcs_${lastIndex}`]?.focus();

                NotificationSound("warning", "All pieces already added.!");

                return prev;
            }

            return {
                ...prev,
                weightDetails: [
                    ...rows,
                    {
                        partNo: "",
                        pcs: "",
                        boxNo: "System Generated",
                        weight: "",
                        length: "",
                        width: "",
                        height: "",
                        volumetricWeight: "",
                        boxDescription: "",
                    }
                ]
            };
        });

        setTimeout(() => {
            const nextIndex = formData.weightDetails.length;
            inputrefs.current[`pcs_${nextIndex}`]?.focus();
        }, 100);
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Shipment/InsertUpdateShipmentEntry`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data?.focus, inputrefs, handleClear);
        if (data.status === 'SUCCESS') {
            setawbNoForPrint(data?.awbNo)
        }
    };

    const GetConsignorDetails = async (consignorName) => {
        await dispatch(setSubLoading(true));
        let payload = {
            ConsignorConsigneeCode: consignorName
        };
        let res = await ApiCall(`/api/Shipment/GetConsignorDetails`, payload);
        await dispatch(setSubLoading(false));
        if (res.status === "SUCCESS") {
            setFormData((prev) => ({
                ...prev,
                consignorPinCode: res.data.consignorPinCode,
                consignorCity: res.data.consignorCity,
                consignorState: res.data.consignorState,
                consignorAddress1: res.data.consignorAddress1,
                consignorAddress2: res.data.consignorAddress2,
                consignorAddress3: res.data.consignorAddress3,
                consignorMobileNo: res.data.consignorMobileNo,
                consignorEmailID: res.data.consignorEmailID,
                consignorGSTNO: res.data.consignorGSTNO,
                consignorAadharNo: res.data.consignorAadharNo
            }));

        } else {
            setFormData((prev) => ({
                ...prev,
                consignorPinCode: "",
                consignorCity: "",
                consignorState: "",
                consignorAddress1: "",
                consignorAddress2: "",
                consignorAddress3: "",
                consignorMobileNo: "",
                consignorEmailID: "",
                consignorGSTNO: "",
                consignorAadharNo: "",
            }));
            //await NotificationSound(res.status, res.message, res?.focus, inputrefs);
            console.log("Error")
        }
    };
    const getPickupRequest = async (pickupRequestNo) => {
        const body = {
            pickupRequestNo: pickupRequestNo
        };
        await dispatch(setSubLoading(true))
        const res = await ApiCall("/api/PickupRequest/GetPickupRequest", body);
        await dispatch(setSubLoading(false))
        if (res?.status === "SUCCESS") {
            setFormData((prev) => ({
                ...prev,
                pickupPoint: res?.data?.pickupLocation,
                consignorMobileNo: res?.data?.consignorMobileNo,
                totalPcs: res?.data?.pieces,
            }));
            GetClientDetails(res?.data?.client || loginUserClientCode || "")
        } else {
            NotificationSound(res.status, res.message, res.focus, inputrefs)
        }
    };
    const GetPickUpDetails = async (PickupPoint) => {
        await dispatch(setSubLoading(true));

        const payload = {
            Client: loginUserClientCode || "",
            PickupPoint: PickupPoint || ""
        };
        const res = await ApiCall(`/api/Shipment/GetConsignorByPickupPoint`, payload);
        await dispatch(setSubLoading(false));

        const isForward = formData?.bookingType?.toUpperCase() === "FORWARD";
        const prefix = isForward ? "consignor" : "consignee";

        if (res.status === "SUCCESS") {
            const response = res?.data || {};
            const sourceData = {
                Name: response.consignorName || "",
                CompanyName: response.consignorCompanyName || "",
                PinCode: response.consignorPinCode || "",
                City: response.consignorCity || "",
                State: response.consignorState || "",
                Address1: response.consignorAddress1 || "",
                Address2: response.consignorAddress2 || "",
                Address3: response.consignorAddress3 || "",
                MobileNo: response.consignorMobileNo || "",
                EmailID: response.consignorEmailID || "",
                GSTNO: response.consignorGSTNO || "",
                AadharNO: response.consignorAadharNo || ""
            };

            setFormData((prev) => ({
                ...prev,
                [`${prefix}Name`]: sourceData.Name,
                [`${prefix}CompanyName`]: sourceData.CompanyName,
                [`${prefix}PinCode`]: sourceData.PinCode,
                [`${prefix}City`]: sourceData.City,
                [`${prefix}State`]: sourceData.State,
                [`${prefix}Address1`]: sourceData.Address1,
                [`${prefix}Address2`]: sourceData.Address2,
                [`${prefix}Address3`]: sourceData.Address3,
                [`${prefix}MobileNo`]: sourceData.MobileNo,
                [`${prefix}EmailID`]: sourceData.EmailID,
                [`${prefix}GSTNO`]: sourceData.GSTNO,
                [`${prefix}AadharNO`]: sourceData.AadharNO
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [`${prefix}Name`]: "",
                [`${prefix}CompanyName`]: "",
                [`${prefix}PinCode`]: "",
                [`${prefix}City`]: "",
                [`${prefix}State`]: "",
                [`${prefix}Address1`]: "",
                [`${prefix}Address2`]: "",
                [`${prefix}Address3`]: "",
                [`${prefix}MobileNo`]: "",
                [`${prefix}EmailID`]: "",
                [`${prefix}GSTNO`]: "",
                [`${prefix}AadharNO`]: ""
            }));
            console.log("Error");
        }
    };


    const GetConsigneeDetails = async (consigneeName) => {
        await dispatch(setSubLoading(true));
        let payload = {
            ConsignorConsigneeCode: consigneeName
        };
        let res = await ApiCall(`/api/Shipment/GetConsigneeDetails`, payload);
        await dispatch(setSubLoading(false));
        if (res.status === "SUCCESS") {
            setFormData((prev) => ({
                ...prev,
                consigneeCompanyName: res.data.consigneeCompanyName,
                consigneePinCode: res.data.consigneePinCode,
                consigneeCity: res.data.consigneeCity,
                consigneeState: res.data.consigneeState,
                consigneeAddress1: res.data.consigneeAddress1,
                consigneeAddress2: res.data.consigneeAddress2,
                consigneeAddress3: res.data.consigneeAddress3,
                consigneeMobileNo: res.data.consigneeMobileNo,
                consigneeEmailID: res.data.consigneeEmailID,
                consigneeGSTNO: res.data.consigneeGSTNO,
                consigneeAadharNO: res.data.consigneeAadharNO,
                destinationBranch: res.data.destinationBranch
            }));

        } else {
            setFormData((prev) => ({
                ...prev,
                consigneeCompanyName: "",
                consigneePinCode: "",
                consigneeCity: "",
                consigneeState: "",
                consigneeAddress1: "",
                consigneeAddress2: "",
                consigneeAddress3: "",
                consigneeMobileNo: "",
                consigneeEmailID: "",
                consigneeGSTNO: "",
                consigneeAadharNO: "",
            }));
            //await NotificationSound(res.status, res.message, res?.focus, inputrefs);
            console.log("Error")
        }
    };

    const GetClientDetails = async (client) => {
        await dispatch(setSubLoading(true));

        let payload = {
            Client: client
        };
        let res = await ApiCall(`/api/Shipment/GetClientDetails`, payload);
        await dispatch(setSubLoading(false));
        if (res.status === "SUCCESS") {
            setFormData((prev) => ({
                ...prev,
                consignorName: res?.data?.consignorName,
                consignorCompanyName: res?.data?.consignorCompanyName,
                consignorPinCode: res?.data?.consignorPinCode,
                consignorCity: res?.data?.consignorCity,
                consignorState: res?.data?.consignorState,
                consignorAddress1: res?.data?.consignorAddress1,
                consignorAddress2: res?.data?.consignorAddress2,
                consignorAddress3: res?.data?.consignorAddress3,
                consignorMobileNo: res?.data?.consignorMobileNo,
                consignorEmailID: res?.data?.consignorEmailID,
                consignorGSTNO: res?.data?.consignorGSTNO,
                consignorAadharNo: res?.data?.consignorAadharNo,
                paymentType: res?.data?.paymentType ? res?.data?.paymentType : setIspayment(true),
                salesPerson: res?.data?.salesPerson,
                divisor: res?.data?.divisor,
                buisnessType: res?.data?.buisnessType,
                volumetricSelection: res?.data?.volumetricSelection
            }));
            setValidateFeild({
                buisnessType: res?.data?.buisnessType,
                volumetricSelection: res?.data?.volumetricSelection
            })
        } else {
            setFormData((prev) => ({
                ...prev,
                consignorName: "",
                consignorCompanyName: "",
                consignorPinCode: "",
                consignorCity: "",
                consignorState: "",
                consignorAddress1: "",
                consignorAddress2: "",
                consignorAddress3: "",
                consignorMobileNo: "",
                consignorEmailID: "",
                consignorGSTNO: "",
                consignorAadharNo: "",
                paymentType: "",
                salesPerson: "",
                divisor: "",
                buisnessType: "",
                volumetricSelection: "",
            }));
            console.log("Error")
        }
    };


    const GetPartNoDetails = async (partNo, index) => {
        await dispatch(setSubLoading(true));
        let payload = {
            Client: loginUserClientCode || "",
            partNo: partNo || "",
        };
        let res = await ApiCall(`/api/Shipment/GetPartNoDetails`, payload);
        await dispatch(setSubLoading(false));

        setFormData((pre) => {
            const updatedRows = [...pre.weightDetails];

            const length = parseFloat(res.length) || 0;
            const width = parseFloat(res.width) || 0;
            const height = parseFloat(res.height) || 0;
            const divisor = parseFloat(pre.divisor) || 5000;
            const cft = parseFloat(pre.cft) || 1;
            const volumetricSelection = pre.volumetricSelection;
            const pcs = parseFloat(updatedRows[index].pcs) || 1;
            let volumetricWeight = "";

            if (length && width && height && divisor) {
                const isInch = volumetricSelection?.toUpperCase() === 'INCH';
                let baseVolume = length * width * height;
                if (isInch && cft) {
                    baseVolume *= cft;
                }
                if (isPcsMultiply && pcs) {
                    baseVolume *= pcs;
                }
                const volWeight = baseVolume / divisor;
                volumetricWeight = Number(volWeight).toFixed(3);
            }

            updatedRows[index] = {
                ...updatedRows[index],
                length: res.length || "",
                width: res.width || "",
                height: res.height || "",
                weight: res.actualWeight || "",
                boxDescription: res.description || "",
                volumetricWeight: volumetricWeight,
            };
            const allDescriptions = updatedRows.map(r => r.boxDescription).filter(Boolean);
            return {
                ...pre,
                weightDetails: updatedRows,
                packetDescription: [...new Set(allDescriptions)].join(", ")
            };
        });
    };

    //--Multiple Add Invoice--//
    const [isItemDetailsEdit, setIsItemDetailsEdit] = useState(false)
    const [editcontactIndex, setEditcontactIndex] = useState('')
    const [packetDetail, setPacketDetail] = useState({
        "invoiceNo": "",
        "invoiceDate": "",
        "invoiceValue": "",
        "ewayBillNo": "",
        "ewayBillExpDate": ""
    })

    // Validate contract Fields
    const ValidateItemDetails = async () => {

        const { invoiceNo, invoiceDate, invoiceValue, ewayBillNo, ewayBillExpDate } = packetDetail;

        if (!invoiceNo?.trim()) {
            await NotificationSound('Error', 'Please enter Invoice No!', 'txtInvoiceNo', inputrefs);
            return false;
        }

        if (!invoiceDate) {
            await NotificationSound('Error', 'Please select Invoice Date!', 'txtInvoiceDate', inputrefs);
            return false;
        }

        if (!invoiceValue?.toString().trim()) {
            await NotificationSound('Error', 'Please enter Invoice Value!', 'txtInvoiceValue', inputrefs);
            return false;
        }
        if (!ewayBillNo?.toString().trim() && Number(invoiceValue) >= 50000) {
            await NotificationSound('Error', 'Please enter Eway Bill No!', 'txtEWayBillNo', inputrefs);
            return false;
        }
        if (ewayBillNo !== "" && (ewayBillNo.length !== 10 && ewayBillNo.length !== 12)) {
            await NotificationSound('Error', 'Please enter valid Eway Bill No!', 'txtEWayBillNo', inputrefs);
            return false;
        }
        if (!ewayBillExpDate?.toString().trim() && Number(invoiceValue) >= 50000) {
            await NotificationSound('Error', 'Please enter Eway Bill Exp Date!', 'txtEWayBillExpDate', inputrefs);
            return false;
        }

        const duplicateInvoice = formData?.invoiceDetails?.find(
            (item, index) => item.invoiceNo === invoiceNo && (!isItemDetailsEdit || index !== editcontactIndex)
        );

        if (duplicateInvoice) {
            await NotificationSound('Error', 'Invoice No already exists!', 'txtInvoiceNo', inputrefs);
            return false;
        }

        if (ewayBillNo?.trim()) {
            const duplicateEwayBill = formData?.invoiceDetails?.find(
                (item, index) => item.ewayBillNo === ewayBillNo && (!isItemDetailsEdit || index !== editcontactIndex)
            );

            if (duplicateEwayBill) {
                await NotificationSound('Error', 'E-Way Bill No already exists!', 'txtEWayBillNo', inputrefs);
                return false;
            }
        }

        return true;
    };

    const getAwbDetails = async (awbNo) => {
        const body = {
            AwbNo: awbNo
        };
        await dispatch(setSubLoading(true))
        const res = await ApiCall("/api/Shipment/GetPickupAwbNoDetails", body);
        await dispatch(setSubLoading(false))
        if (res?.status === "SUCCESS") {
            setFormData((prev) => ({
                ...prev,
                ...res
            }));
            setawbNoForPrint(res?.awbNo)
        } else {
            NotificationSound(res.status, res.message, res.focus, inputrefs)
        }
    };

    const handleAddInvoice = async () => {
        const isValid = await ValidateItemDetails();
        if (!isValid) return;

        let updatedList = [...(formData.invoiceDetails || [])];

        if (isItemDetailsEdit) {
            updatedList[editcontactIndex] = { ...packetDetail };
        } else {
            updatedList.push({ ...packetDetail });
        }

        setFormData(prev => ({
            ...prev,
            invoiceDetails: updatedList
        }));

        handleClearInvoice();
    };

    // Edit
    const handleEditInvoice = (item, index) => {
        setPacketDetail({ ...item });
        setIsItemDetailsEdit(true);
        setEditcontactIndex(index);
    };


    const handleDeleteInvoice = (index) => {

        let updatedList = [...formData.invoiceDetails];
        updatedList.splice(index, 1);

        setFormData(prev => ({
            ...prev,
            invoiceDetails: updatedList
        }));

        handleClearInvoice();
    };


    // handle clear
    const handleClearInvoice = () => {
        setPacketDetail({
            invoiceNo: "",
            invoiceDate: "",
            invoiceValue: "",
            ewayBillNo: "",
            ewayBillExpDate: ""
        });
        setIsItemDetailsEdit(false);
        setEditcontactIndex('');
    };

    const GetCityStateByPincode = async (dataPayload, type) => {
        await dispatch(setSubLoading(true));
        let data = await ApiCall(`/api/Dashboard/GetPinCodeByCityState`, dataPayload);
        await dispatch(setSubLoading(false));

        if (data?.city || data?.state) {
            setFormData(prev => ({
                ...prev,
                ...(type === "consignor" && {
                    consignorCity: data?.city || "",
                    consignorState: data?.state || ""
                }),
                ...(type === "consignee" && {
                    consigneeCity: data?.city || "",
                    consigneeState: data?.state || "",
                    destinationBranch: data?.destinationBranch || ""
                })
            }));
        }
    };

    useEffect(() => {
        let totalWeight = 0;
        let totalVolWeight = 0;

        formData.weightDetails.forEach((row) => {
            const weight = parseFloat(row.weight) || 0;
            const pcs = parseInt(row.pcs) || 0;
            const volWeight = parseFloat(row.volumetricWeight) || 0;
            if (isPcsMultiply) {
                totalWeight += weight * pcs;
            } else {
                totalWeight += weight
            }
            totalVolWeight += volWeight;
        });

        const newTotalWeight = totalWeight.toFixed(3);
        const newVol = totalVolWeight.toFixed(3);

        const chargeWeight = Math.max(
            parseFloat(newTotalWeight),
            parseFloat(newVol)
        ).toFixed(3);

        if (
            formData.totalWeight !== newTotalWeight ||
            formData.totalVolumetricWeight !== newVol ||
            formData.totalChargeWeight !== chargeWeight ||
            formData.actualWeight !== newTotalWeight
        ) {
            setFormData((prev) => ({
                ...prev,
                actualWeight: newTotalWeight,
                totalWeight: newTotalWeight,
                totalVolumetricWeight: newVol,
                totalChargeWeight: chargeWeight
            }));
        }
    }, [formData.weightDetails]);


    const getDivisorAndCft = async (value, client, serviceMode) => {
        await dispatch(setSubLoading(true));

        let payload = {
            VolumetricSelection: value ? value : "",
            Client: client ? client : loginUserClientCode ? loginUserClientCode : "",
            ServiceMode: serviceMode ? serviceMode : "",
        };

        let res = await ApiCall(
            `/api/Shipment/GetServiceDetails`,
            payload
        );

        await dispatch(setSubLoading(false));

        if (res.status === "SUCCESS") {
            const newDivisor = parseFloat(res?.data?.divisor) || 5000;
            const newCft = parseFloat(res?.data?.cft) || 1;

            setFormData((prev) => {
                const updatedRows = prev.weightDetails.map((row) => {
                    const length = parseFloat(row.length) || 0;
                    const width = parseFloat(row.width) || 0;
                    const height = parseFloat(row.height) || 0;
                    const pcs = parseFloat(row.pcs) || 1;

                    let updatedRow = { ...row };

                    if (length && width && height && newDivisor) {
                        const isInch =
                            prev?.volumetricSelection?.toUpperCase() ===
                            "INCH";

                        let baseVolume =
                            length * width * height;

                        if (isInch && newCft) {
                            baseVolume *= newCft;
                        }

                        if (isPcsMultiply && pcs) {
                            baseVolume *= pcs;
                        }

                        const volWeight =
                            baseVolume / newDivisor;

                        updatedRow.volumetricWeight =
                            Number(volWeight).toFixed(3);
                    } else {
                        updatedRow.volumetricWeight = "";
                    }

                    return updatedRow;
                });

                return {
                    ...prev,
                    divisor: newDivisor,
                    cft: newCft,
                    weightDetails: updatedRows,
                };
            });
        } else {
            setFormData((prev) => ({
                ...prev,
                divisor: 5000,
            }));
        }
    };

    //Docket Print
    const handlePrint = () => {
        const params = new URLSearchParams({
            awbNo: awbNoForPrint,

        });
        const url = `/Print/LabelPrint?${params.toString()}`;
        window.open(url, "_blank");
    };

    const handleSeeAndPrint = () => {
        window.open(
            `${virtualPath}/CNotePrint?AWBNo=${awbNoForPrint}`,
            "_blank"
        );
    };

    const handleLabelPrint = () => {
        window.open(
            `${virtualPath}/LabelPrint?AWBNo=${awbNoForPrint}`,
            "_blank"
        );
    };


    useEffect(() => {
        const data = GetServiceType?.data?.dropDownData;

        if (data && data.length === 1) {
            setFormData((prev) => ({
                ...prev,
                serviceType: data[0].valuePart
            }));
        }
    }, [GetServiceType]);


    useEffect(() => {
        document.title = `Shipment Entry`
        inputrefs.current['txtPickupRequestNo'].focus()
        GetClientDetails(loginUserClientCode);
    }, [])
    
    const renderTopToolbar = () => {
        return (
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-3 bg-white p-2 rounded-xl shadow-sm border border-gray-250">
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-indigo-50 text-indigo-600 rounded-xl">
                        <Users className="w-6 h-6" />
                    </div>
                    <div>
                        <h1 className="text-lg font-bold text-gray-800 m-0 leading-tight">Shipment Entry</h1>
                        <p className="text-xs text-gray-500 m-0">Logistics shipment pickup booking & processing</p>
                    </div>
                </div>
                <div className="flex items-center">
                    <Switch
                        divclassname="flex items-center gap-1 scale-90"
                        labelclass='flex items-center gap-2 cursor-pointer select-none'
                        id="txtUpdateAwbNo"
                        label="Update Docket No"
                        checked={formData.isUpdateAwbNo}
                        onChange={(e) => {
                            setFormData({ ...formData, isUpdateAwbNo: e.target.checked })
                        }}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                formData.isUpdateAwbNo ?
                                    inputrefs.current['txtAWBNo'].focus() :
                                    inputrefs.current['txtPickupDate'].focus();
                            }
                        }}
                    />
                </div>
            </div>
        );
    };

    const renderClassicHeader = () => {
        return (
            <div className="flex items-center justify-between w-full">
                <div className="flex items-center gap-2">
                    <Users className="w-5 h-5 text-primary-600" />
                    <h2 className="text-base font-semibold text-primary-600">
                        Pickup Entry
                    </h2>
                </div>
            </div>
        );
    };

    const renderGeneralDetails = (isAdvanced) => {
        const body = (
            <>
                <InputBox
                    id="txtAWBNo"
                    label="Docket No"
                    disabled={!(formData.isMannualAwbNo || formData.isUpdateAwbNo)}
                    placeholder={
                        !(formData.isMannualAwbNo || formData.isUpdateAwbNo)
                            ? "System Generated"
                            : "Enter Docket No"
                    }
                    value={formData.awbNo || ""}
                    onChange={(e) =>
                        setFormData({ ...formData, awbNo: e.target.value })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            if (formData.isUpdateAwbNo) {
                                getAwbDetails(formData.awbNo);
                            }
                          
                            inputrefs.current['txtPickupRequestNo'].focus();
                        }
                    }}
                    labelclass="flex"
                    extraElement={
                        !formData.isUpdateAwbNo && (
                            <div className="ms-2 flex items-center gap-1">
                                <input
                                    type="checkbox"
                                    id="txtManual"
                                    checked={formData.isMannualAwbNo}
                                    onChange={(e) =>
                                        setFormData({ ...formData, isMannualAwbNo: e.target.checked })
                                    }
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            inputrefs.current['btnSub'].focus();
                                        }
                                    }}
                                />
                                <label htmlFor="txtManual" className={isAdvanced ? "text-xs text-gray-500 font-normal" : "text-sm"}>
                                    Manual
                                </label>
                            </div>
                        )
                    }
                />
                <InputBox
                    id="txtPickupRequestNo"
                    label="Pickup Request No "
                    placeholder="Enter Pickup Request No"
                    value={formData.pickupRequestNo}
                    maxLength='50'
                    onChange={(e) =>
                        setFormData({ ...formData, pickupRequestNo: (e.target.value) })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            if (formData.pickupRequestNo?.trim()) {
                                getPickupRequest(formData.pickupRequestNo);
                                inputrefs.current["txtPickupDate"]?.focus();
                            }
                            inputrefs.current["txtPickupDate"]?.focus();
                        }
                    }}
                />
                <DateBox
                    inputrefs={inputrefs}
                    label="Pickup Date"
                    id="txtPickupDate"
                    required
                    selected={
                        formData?.pickupDate
                            ? new Date(formData.pickupDate)
                            : null
                    }
                    onChange={(date) =>
                        handleDateChange(date, setFormData, formData, 'pickupDate')
                    }
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtBookingType']?.focus()
                        }
                    }}
                />

                <SelectInputBox
                    id="txtBookingType"
                    value={formData.bookingType}
                    label='Booking Type'
                    required
                    onChange={(e) => setFormData({ ...formData, bookingType: e.target.value })}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            inputrefs.current['txtPickupPoint'].focus();
                        }
                    }}
                >
                    <option value=''>--Please Select--</option>
                    {getBookingType?.data?.dropDownData?.map((item, index) =>
                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                    )}
                </SelectInputBox>


                <SelectInputBox
                    id="txtPickupPoint"
                    value={formData.pickupPoint}
                    label='Pickup Point'
                    onChange={(e) => {
                        setFormData({ ...formData, pickupPoint: e.target.value })
                        GetPickUpDetails(e.target.value)
                    }}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            inputrefs.current['txtServiceMode'].focus()
                        }
                    }}
                >
                    <option value=''>--Please Select--</option>
                    {GetPickupPoint?.data?.dropDownData?.map((item, index) =>
                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                    )}
                </SelectInputBox>

                <SelectInputBox
                    id="txtBuisnessType"
                    value={formData.buisnessType}
                    disabled={validateFeild.buisnessType.toUpperCase() !== ''}
                    label='Business Type'
                    required
                    onChange={(e) => setFormData({ ...formData, buisnessType: e.target.value })}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            inputrefs.current['txtServiceMode'].focus()
                        }
                    }}
                >
                    <option value=''>--Please Select--</option>
                    {GetBuisnessType?.data?.dropDownData?.map((item, index) =>
                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                    )}
                </SelectInputBox>

                <SelectInputBox
                    id="txtServiceMode"
                    value={formData.serviceMode}
                    label='Mode'
                    required
                    onChange={(e) => {
                        setFormData({ ...formData, serviceMode: e.target.value })
                        getDivisorAndCft(formData.volumetricSelection, loginUserClientCode, e.target.value)
                    }}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            inputrefs.current['txtConsignorName'].focus()
                        }
                    }}
                >
                    <option value=''>--Please Select--</option>
                    {GetServiceMode?.data?.dropDownData?.map((item, index) =>
                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                    )}
                </SelectInputBox>
            </>
        );

        if (!isAdvanced) {
            return body;
        }

        return (
            <div className="bg-white shadow-sm rounded-xl p-3 border border-gray-200/80 hover:shadow-md transition-all duration-200">
                <div className="flex items-center justify-between mb-2 pb-1.5 border-b border-gray-100">
                    <div className="flex items-center gap-2">
                        <Receipt className="w-4 h-4 text-indigo-600" />
                        <h3 className="text-xs font-bold text-gray-800 m-0">Shipment Specifications</h3>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
                    {body}
                </div>
            </div>
        );
    };

    const renderConsignorDetails = (isAdvanced) => {
        const body = (
            <>
                <AutoCompleteBoxNew
                    id="txtConsignorName"
                    label="Consignor Name"
                    required
                    placeholder="Enter Consignor Name"
                    value={formData.consignorName || ""}
                    autocompleteType="GetConsignor"
                    onChange={async (event, newInputValue) => {
                        newInputValue = newInputValue || '';
                        if (event.type !== 'keydown') {
                            const updatedData = { ...formData, consignorName: newInputValue };
                            setFormData(updatedData);
                            GetConsignorDetails(newInputValue ? newInputValue : "")
                        }
                    }}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsignorCompanyName']?.focus();
                        }
                    }}
                    contextKey={loginUserClientCode}
                />

                <InputBox
                    id="txtConsignorCompanyName"
                    label="Company Name"
                    placeholder="Enter Company Name"
                    value={formData.consignorCompanyName}
                    onChange={(e) =>
                        setFormData({ ...formData, consignorCompanyName: e.target.value })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsignorPinCode']?.focus();
                        }
                    }}
                />

                <AutoCompleteBoxNumeric
                    id="txtConsignorPinCode"
                    label="Pincode"
                    placeholder="Enter Pincode"
                    autocompleteType="GetPinCode"
                    value={formData.consignorPinCode || ""}
                    onChange={async (event, newInputValue) => {
                        newInputValue = newInputValue || '';
                        if (event.type !== 'keydown') {
                            const updatedData = { ...formData, consignorPinCode: newInputValue };
                            setFormData(updatedData);
                            GetCityStateByPincode({ pincode: newInputValue }, "consignor");
                        }
                    }}
                    required
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsignorCity'].focus()
                        }
                    }}
                    maxLength='6'
                />

                <AutoCompleteBoxNew
                    id="txtConsignorCity"
                    label="City"
                    required
                    placeholder="Enter City"
                    autocompleteType="GetCityByPinCode"
                    value={formData.consignorCity}
                    onChange={async (event, newInputValue) => {
                        newInputValue = newInputValue || '';
                        if (event.type !== 'keydown') {
                            const updatedData = { ...formData, consignorCity: newInputValue };
                            setFormData(updatedData);
                        }
                    }}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsignorState']?.focus();
                        }
                    }}
                />

                <AutoCompleteBoxNew
                    id="txtConsignorState"
                    label="State"
                    required
                    placeholder="Enter State"
                    value={formData.consignorState}
                    autocompleteType="GetCityWiseState"
                    onChange={async (event, newInputValue) => {
                        newInputValue = newInputValue || '';
                        if (event.type !== 'keydown') {
                            const updatedData = { ...formData, consignorState: newInputValue };
                            setFormData(updatedData);
                        }
                    }}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsignorAddress1']?.focus();
                        }
                    }}
                />

                <InputBox
                    id="txtConsignorAddress1"
                    label="Address 1"
                    required
                    placeholder="Enter Address 1"
                    value={formData.consignorAddress1}
                    onChange={(e) =>
                        setFormData({ ...formData, consignorAddress1: e.target.value })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsignorAddress2']?.focus();
                        }
                    }}
                />

                <InputBox
                    id="txtConsignorAddress2"
                    label="Address 2"
                    placeholder="Enter Address 2"
                    value={formData.consignorAddress2}
                    onChange={(e) =>
                        setFormData({ ...formData, consignorAddress2: e.target.value })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsignorAddress3']?.focus();
                        }
                    }}
                />

                <InputBox
                    id="txtConsignorAddress3"
                    label="Address 3"
                    placeholder="Enter Address 3"
                    value={formData.consignorAddress3}
                    onChange={(e) =>
                        setFormData({ ...formData, consignorAddress3: e.target.value })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsignorMobileNo']?.focus();
                        }
                    }}
                />

                <InputBox
                    id="txtConsignorMobileNo"
                    label="Mobile No"
                    required
                    type="text"
                    placeholder="Enter Mobile No"
                    value={formData.consignorMobileNo}
                    onChange={(e) =>
                        setFormData({ ...formData, consignorMobileNo: convertToNumber(e.target.value) })
                    }
                    maxlength="10"
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsignorEmailId']?.focus();
                        }
                    }}
                />

                <InputBox
                    id="txtConsignorEmailId"
                    label="Email"
                    placeholder="Enter Email"
                    value={formData.consignorEmailID}
                    onChange={(e) =>
                        setFormData({ ...formData, consignorEmailID: e.target.value })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            formData.isInsurance ?
                                inputrefs.current['txtInsuranceValue']?.focus() :
                                inputrefs.current['txtConsigneeName']?.focus();
                        }
                    }}
                />

                {formData.isInsurance && (
                    <InputBox
                        id="txtInsuranceValue"
                        label="Insurance Value"
                        value={formData.insuranceValue}
                        required
                        maxLength='10'
                        onChange={(e) =>
                            setFormData({ ...formData, insuranceValue: convertTwoDecimalsOnValue(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtConsigneeName"]?.focus();
                            }
                        }}
                        placeholder="Enter Insurance Value"
                    />
                )}
            </>
        );

        if (!isAdvanced) {
            return (
                <div className="bg-white p-3 pt-2 rounded-md mt-3 shadow-md rounded-md border-t-4 border-green-600">
                    <div className="flex mb-2 items-center gap-2">
                        <UsersRound size={18} className="text-green-600" />
                        <div className="flex justify-between items-center w-full">
                            <h2 className="text-base font-semibold text-gray-800">
                                Consignor Details
                            </h2>
                            <div className="flex items-center gap-3">
                                <Switch
                                    divclassname="ms-2 scale-90"
                                    id="txtConsignorSave"
                                    label="Consignor Save"
                                    labelclass='flex items-center gap-2 cursor-pointer select-none'
                                    checked={formData.isConsignorSave}
                                    onChange={(e) =>
                                        setFormData({ ...formData, isConsignorSave: e.target.checked })
                                    }
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            inputrefs.current['txtConsignorName'].focus()
                                        }
                                    }}
                                />
                                <div className="flex items-center gap-1">
                                    <input
                                        type="checkbox"
                                        id="txtInsurance"
                                        checked={formData.isInsurance}
                                        onChange={(e) =>
                                            setFormData({ ...formData, isInsurance: e.target.checked })
                                        }
                                    />
                                    <label htmlFor="txtInsurance" className="text-sm">
                                        Insurance
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-x-3 gap-y-2 items-start">
                        {body}
                    </div>
                </div>
            );
        }

        return (
            <div className="bg-white shadow-sm rounded-xl p-3 border border-gray-200/80 hover:shadow-md transition-all duration-200">
                <div className="flex items-center justify-between mb-2 pb-1.5 border-b border-gray-100">
                    <div className="flex items-center gap-2">
                        <UsersRound className="w-4 h-4 text-green-600" />
                        <h3 className="text-xs font-bold text-gray-800 m-0">Consignor Information</h3>
                    </div>
                    <div className="flex items-center gap-3">
                        <Switch
                            divclassname="scale-90"
                            id="txtConsignorSave"
                            label="Consignor Save"
                            labelclass='flex items-center gap-1.5 cursor-pointer select-none text-xs font-medium text-gray-600'
                            checked={formData.isConsignorSave}
                            onChange={(e) =>
                                setFormData({ ...formData, isConsignorSave: e.target.checked })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsignorName'].focus()
                                }
                            }}
                        />
                        <div className="flex items-center gap-1.5">
                            <input
                                type="checkbox"
                                id="txtInsurance"
                                className="w-3.5 h-3.5 text-green-600 border-gray-300 rounded focus:ring-green-500"
                                checked={formData.isInsurance}
                                onChange={(e) =>
                                    setFormData({ ...formData, isInsurance: e.target.checked })
                                }
                            />
                            <label htmlFor="txtInsurance" className="text-xs font-medium text-gray-600 select-none">
                                Insurance
                            </label>
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {body}
                </div>
            </div>
        );
    };

    const renderConsigneeDetails = (isAdvanced) => {
        const body = (
            <>
                <AutoCompleteBoxNew
                    id="txtConsigneeName"
                    label="Consignee Name"
                    required
                    placeholder="Enter Consignee Name"
                    value={formData.consigneeName || ""}
                    autocompleteType="GetConsignee"
                    onChange={async (event, newInputValue) => {
                        newInputValue = newInputValue || '';
                        if (event.type !== 'keydown') {
                            const updatedData = { ...formData, consigneeName: newInputValue };
                            setFormData(updatedData);
                            GetConsigneeDetails(newInputValue ? newInputValue : "")
                        }
                    }}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsigneeCompanyName'].focus()
                        }
                    }}
                    contextKey={loginUserClientCode}
                />

                <InputBox
                    id="txtConsigneeCompanyName"
                    label="Company Name"
                    placeholder="Enter Company Name"
                    value={formData.consigneeCompanyName}
                    onChange={(e) =>
                        setFormData({ ...formData, consigneeCompanyName: e.target.value })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsigneePinCode']?.focus();
                        }
                    }}
                />

                <AutoCompleteBoxNumeric
                    id="txtConsigneePinCode"
                    label="Pincode"
                    placeholder="Enter Pincode"
                    autocompleteType="GetPinCode"
                    value={formData.consigneePinCode || ""}
                    onChange={async (event, newInputValue) => {
                        newInputValue = newInputValue || '';
                        if (event.type !== 'keydown') {
                            const updatedData = { ...formData, consigneePinCode: newInputValue };
                            setFormData(updatedData);
                            GetCityStateByPincode({ pincode: newInputValue }, "consignee");
                        }
                    }}
                    required
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsigneeCity'].focus()
                        }
                    }}
                    maxLength='6'
                />

                <AutoCompleteBoxNew
                    id="txtConsigneeCity"
                    label="City"
                    placeholder="Enter City"
                    autocompleteType="GetCityByPinCode"
                    required
                    value={formData.consigneeCity}
                    onChange={async (event, newInputValue) => {
                        newInputValue = newInputValue || '';
                        if (event.type !== 'keydown') {
                            const updatedData = { ...formData, consigneeCity: newInputValue };
                            setFormData(updatedData);
                        }
                    }}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsigneeState']?.focus();
                        }
                    }}
                />

                <AutoCompleteBoxNew
                    id="txtConsigneeState"
                    label="State"
                    placeholder="Enter State"
                    value={formData.consigneeState}
                    required
                    autocompleteType="GetCityWiseState"
                    onChange={async (event, newInputValue) => {
                        newInputValue = newInputValue || '';
                        if (event.type !== 'keydown') {
                            const updatedData = { ...formData, consigneeState: newInputValue };
                            setFormData(updatedData);
                        }
                    }}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsigneeAddress1']?.focus();
                        }
                    }}
                />

                <InputBox
                    id="txtConsigneeAddress1"
                    label="Address 1"
                    placeholder="Enter Address 1"
                    required
                    value={formData.consigneeAddress1}
                    onChange={(e) =>
                        setFormData({ ...formData, consigneeAddress1: e.target.value })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsigneeAddress2']?.focus();
                        }
                    }}
                />

                <InputBox
                    id="txtConsigneeAddress2"
                    label="Address 2"
                    placeholder="Enter Address 2"
                    value={formData.consigneeAddress2}
                    onChange={(e) =>
                        setFormData({ ...formData, consigneeAddress2: e.target.value })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsigneeAddress3']?.focus();
                        }
                    }}
                />

                <InputBox
                    id="txtConsigneeAddress3"
                    label="Address 3"
                    placeholder="Enter Address 3"
                    value={formData.consigneeAddress3}
                    onChange={(e) =>
                        setFormData({ ...formData, consigneeAddress3: e.target.value })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsigneeMobileNo']?.focus();
                        }
                    }}
                />

                <InputBox
                    id="txtConsigneeMobileNo"
                    label="Mobile No"
                    placeholder="Enter Mobile No"
                    required
                    type="text"
                    value={formData.consigneeMobileNo}
                    maxlength="10"
                    onChange={(e) =>
                        setFormData({ ...formData, consigneeMobileNo: convertToNumber(e.target.value) })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtConsigneeEmailId']?.focus();
                        }
                    }}
                />

                <InputBox
                    id="txtConsigneeEmailId"
                    label="Email"
                    placeholder="Enter Email"
                    value={formData.consigneeEmailID}
                    onChange={(e) =>
                        setFormData({ ...formData, consigneeEmailID: e.target.value })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtGSTNo']?.focus();
                        }
                    }}
                />
                <InputBox
                    id="txtGSTNo"
                    label="GST No"
                    placeholder="GST No"
                    value={formData.consigneeGSTNO}
                    onChange={(e) =>
                        setFormData({ ...formData, consigneeGSTNO: sanitizeInput(e.target.value) })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtTotalPcs']?.focus();
                        }
                    }}
                />
            </>
        );

        if (!isAdvanced) {
            return (
                <div className="bg-white p-3 pt-2 rounded-md mt-3 shadow-md rounded-md border-t-4 border-blue-600">
                    <div className="flex mb-2 items-center gap-2">
                        <UsersRound size={18} className="text-blue-600" />
                        <div className="flex justify-between items-center w-full">
                            <h2 className="text-base font-semibold text-gray-800">
                                Consignee Details
                            </h2>
                            <Switch
                                divclassname="ms-2 scale-90"
                                id="txtConsigneeSave"
                                label="Consignee Save"
                                labelclass='flex items-center gap-2 cursor-pointer select-none'
                                checked={formData.isConsigneeSave}
                                onChange={(e) =>
                                    setFormData({ ...formData, isConsigneeSave: e.target.checked })
                                }
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        inputrefs.current['txtConsigneeName'].focus()
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-x-3 gap-y-2 items-start">
                        {body}
                    </div>
                </div>
            );
        }

        return (
            <div className="bg-white shadow-sm rounded-xl p-3 border border-gray-200/80 hover:shadow-md transition-all duration-200">
                <div className="flex items-center justify-between mb-2 pb-1.5 border-b border-gray-100">
                    <div className="flex items-center gap-2">
                        <UsersRound className="w-4 h-4 text-blue-600" />
                        <h3 className="text-xs font-bold text-gray-800 m-0">Consignee Information</h3>
                    </div>
                    <Switch
                        divclassname="scale-90"
                        id="txtConsigneeSave"
                        label="Consignee Save"
                        labelclass='flex items-center gap-1.5 cursor-pointer select-none text-xs font-medium text-gray-600'
                        checked={formData.isConsigneeSave}
                        onChange={(e) =>
                            setFormData({ ...formData, isConsigneeSave: e.target.checked })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtConsigneeName'].focus()
                            }
                        }}
                    />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {body}
                </div>
            </div>
        );
    };

    const renderWeightDetails = (isAdvanced) => {
        const tableHeader = (
            <thead className={isAdvanced ? "bg-slate-50 text-slate-700 text-xs uppercase tracking-wider font-semibold border-b border-slate-200" : "bg-gray-100 text-sm"}>
                <tr>
                    <th className="border p-2">Part No</th>
                    <th className="border p-2">Item</th>
                    <th className="border p-2">Pieces</th>
                    <th className="border p-2">Weight</th>
                    {formData.isVolWeight && (
                        <>
                            <th className="border p-2">Length</th>
                            <th className="border p-2">Width</th>
                            <th className="border p-2">Height</th>
                            <th className="border p-2 whitespace-nowrap">Vol. Weight</th>
                        </>
                    )}
                    <th className="border p-2">Description</th>
                    <th className="border p-2">Action</th>
                </tr>
            </thead>
        );

        const tableBody = (
            <tbody>
                {formData.weightDetails.map((item, index) => (
                    <tr key={index} className={isAdvanced ? "hover:bg-slate-50/50 transition-colors" : ""}>
                        <td className="border p-1 w-[18%]">
                            <AutoCompleteBoxNew
                                id={`txtPartNo${index}`}
                                required
                                placeholder="Enter Part No"
                                autocompleteType="GetPartNo"
                                contextKey={loginUserClientCode}
                                value={item.partNo || ''}
                                onChange={async (event, newInputValue) => {
                                    newInputValue = newInputValue || '';
                                    if (event.type !== 'keydown') {
                                        const isDuplicate = formData.weightDetails.some(
                                            (row, i) =>
                                                i !== index &&
                                                row.partNo?.trim()?.toLowerCase() ===
                                                newInputValue.trim().toLowerCase()
                                        );
                                        if (isDuplicate) {
                                            NotificationSound(
                                                "ERROR",
                                                `Part No "${newInputValue}" already added`
                                            );
                                            return;
                                        }
                                        handleRowChange(index, "partNo", newInputValue);
                                        GetPartNoDetails(newInputValue, index);
                                    }
                                }}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        inputrefs.current[`txtItem${index}`]?.focus();
                                    }
                                }}
                            />
                        </td>
                        <td className="border p-1 w-[18%]">

                            <AutoCompleteBoxNew
                                id={`txtItem${index}`}
                                //label="Select Item"
                                //disabled={formData.isUpdate}
                                placeholder="Select Item"
                                autocompleteType="GetItem"
                                value={item.itemCode || ""}
                                onChange={async (event, newInputValue) => {
                                    newInputValue = newInputValue || '';
                                    if (event.type !== 'keydown') {
                                        const isDuplicate = formData.weightDetails.some(
                                            (row, i) =>
                                                i !== index &&
                                                row.itemCode?.trim()?.toLowerCase() ===
                                                newInputValue.trim().toLowerCase()
                                        );
                                        if (isDuplicate) {
                                            NotificationSound(
                                                "ERROR",
                                                `Item "${newInputValue}" already added`
                                            );
                                            return;
                                        }
                                        handleRowChange(index, "itemCode", newInputValue);
                                    }
                                }}
                                required
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        inputrefs.current[`pcs_${index}`].focus()
                                    }
                                }}
                            />
                        </td>
                        <td className="border p-1">
                            <InputBox
                                id={`pcs_${index}`}
                                inputrefs={inputrefs}
                                onFocus={(e) => e.target.select()}
                                value={item.pcs}
                                maxLength='3'
                                onChange={(e) => {
                                    const value = convertToNumber(e.target.value);
                                    const updatedRows = [...formData.weightDetails];
                                    updatedRows[index].pcs = value;
                                    const totalEnteredPcs = updatedRows.reduce((sum, row, i) => {
                                        return sum + (parseInt(row.pcs) || 0);
                                    }, 0);
                                    if (formData.totalPcs === '') {
                                        NotificationSound("ERROR", "Please enter Total Pieces.!", 'txtTotalPcs', inputrefs);
                                        return;
                                    }
                                    if (totalEnteredPcs > (parseInt(formData.totalPcs) || 0)) {
                                        NotificationSound("ERROR", `Total pieces cannot be greter then Total Pieces : ${formData.totalPcs}.`);
                                        return;
                                    }
                                    handleRowChange(index, "pcs", value);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        inputrefs.current[`weight_${index}`]?.focus();
                                    }
                                }}
                                placeholder="Enter Pieces"
                            />
                        </td>

                        <td className="border p-1">
                            <InputBox
                                id={`weight_${index}`}
                                inputrefs={inputrefs}
                                onFocus={(e) => e.target.select()}
                                value={item.weight}
                                maxLength='10'
                                onChange={(e) =>
                                    handleRowChange(index, "weight", convertThreeDecimalsWithoutZero(e.target.value))
                                }
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault()
                                        if (formData.isVolWeight) {
                                            inputrefs.current[`length_${index}`]?.focus();
                                        } else {
                                            inputrefs.current[`BoxDescription_${index}`]?.focus();
                                        }
                                    }
                                }}
                                placeholder="Enter Weight"
                            />
                        </td>

                        {formData.isVolWeight && (
                            <>
                                <td className="border p-1">
                                    <InputBox
                                        id={`length_${index}`}
                                        inputrefs={inputrefs}
                                        onFocus={(e) => e.target.select()}
                                        value={item.length}
                                        maxLength='7'
                                        onChange={(e) =>
                                            handleRowChange(index, "length", convertTwoDecimalsOnValue(e.target.value))
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                inputrefs.current[`width_${index}`]?.focus();
                                            }
                                        }}
                                        placeholder="Enter Length"
                                    />
                                </td>

                                <td className="border p-1">
                                    <InputBox
                                        id={`width_${index}`}
                                        inputrefs={inputrefs}
                                        onFocus={(e) => e.target.select()}
                                        maxLength='7'
                                        value={item.width}
                                        onChange={(e) =>
                                            handleRowChange(index, "width", convertTwoDecimalsOnValue(e.target.value))
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                inputrefs.current[`height_${index}`]?.focus();
                                            }
                                        }}
                                        placeholder="Enter Width"
                                    />
                                </td>

                                <td className="border p-1">
                                    <InputBox
                                        id={`height_${index}`}
                                        inputrefs={inputrefs}
                                        onFocus={(e) => e.target.select()}
                                        value={item.height}
                                        maxLength='7'
                                        onChange={(e) =>
                                            handleRowChange(index, "height", convertTwoDecimalsOnValue(e.target.value))
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault()
                                                inputrefs.current[`BoxDescription_${index}`]?.focus();
                                            }
                                        }}
                                        placeholder="Enter Height"
                                    />
                                </td>

                                <td className="border p-1">
                                    <InputBox
                                        value={item.volumetricWeight}
                                        disabled
                                        placeholder="Auto"
                                    />
                                </td>
                            </>
                        )}

                        <td className="border p-1">
                            <InputBox
                                id={`BoxDescription_${index}`}
                                inputrefs={inputrefs}
                                value={item.boxDescription}
                                maxLength='250'
                                onChange={(e) =>
                                    handleRowChange(index, "boxDescription", (e.target.value))
                                }
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault()
                                        if (formData?.weightDetails?.length - 1 === index) {
                                            inputrefs.current[`btnAdd`]?.focus();
                                        } else {
                                            inputrefs.current[`txtPartNo${index + 1}`]?.focus();
                                        }
                                    }
                                }}
                                placeholder="Enter Description"
                            />
                        </td>

                        <td className="border text-center w-20">
                            <div className='flex gap-2 items-center justify-center'>
                                {index === formData.weightDetails.length - 1 &&
                                    <button
                                        type="button"
                                        ref={(ref) => { inputrefs.current["btnAdd"] = ref }}
                                        className="text-green-500 hover:text-green-700 transition-colors bg-transparent border-0"
                                        onClick={() => handleAddRows(index)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                inputrefs.current[`txtPacketDescription`]?.focus();
                                            }
                                        }}
                                    >
                                        <CirclePlus size={18} />
                                    </button>
                                }
                                {formData.weightDetails.length !== 1 &&
                                    <button
                                        type="button"
                                        className="text-red-500 hover:text-red-700 transition-colors bg-transparent border-0"
                                        onClick={() => handleDeleteRow(index)}
                                    >
                                        <Trash size={18} />
                                    </button>
                                }
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        );

        if (!isAdvanced) {
            return (
                <div className="mt-3 card-body shadow-lg rounded-md border-t-4 border-red-500 p-3 pt-2 bg-white">
                    <div className="flex mb-2 items-center gap-2">
                        <Weight size={18} className="text-red-600" />
                        <div className="flex items-center gap-3 w-full">
                            <h2 className="text-base font-semibold text-gray-800 whitespace-nowrap">
                                Weight Details
                            </h2>
                            <InputBox
                                id="txtTotalPcs"
                                divclassname="col-3 flex justify-center items-center gap-1"
                                label='Total Pieces'
                                onFocus={(e) => e.target.select()}
                                maxLength="3"
                                value={formData.totalPcs}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setFormData({ ...formData, totalPcs: convertToNumber(value) });
                                }}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        if (formData.totalPcs === '') {
                                            NotificationSound('ERROR', 'Please Enter Total Pices.!')
                                            return
                                        }
                                        inputrefs.current["txtVolWeight"]?.focus();
                                    }
                                }}
                                placeholder="Enter Pieces"
                            />
                            <div className="flex items-center gap-1">
                                <input
                                    type="checkbox"
                                    id="txtVolWeight"
                                    ref={(ref) => { inputrefs.current["txtVolWeight"] = ref }}
                                    checked={formData.isVolWeight}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setFormData(prev => ({
                                            ...prev,
                                            isVolWeight: checked,
                                            weightDetails: prev.weightDetails.map(row => ({
                                                ...row,
                                                length: checked ? row.length : "",
                                                width: checked ? row.width : "",
                                                height: checked ? row.height : "",
                                                volumetricWeight: checked ? row.volumetricWeight : ""
                                            }))
                                        }));
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            if (
                                                formData.isVolWeight &&
                                                !(validateFeild.volumetricSelection !== '' && !formData.isVolSelection)
                                            ) {
                                                inputrefs.current["txtVolumetricSelection"]?.focus();
                                            } else {
                                                inputrefs.current["txtPartNo0"]?.focus();
                                            }
                                        }
                                    }}
                                />
                                <label htmlFor="txtVolWeight" className="text-sm">
                                    Volumetric
                                </label>
                            </div>
                            {formData.isVolWeight &&
                                <SelectInputBox
                                    id="txtVolumetricSelection"
                                    value={formData.volumetricSelection}
                                    divclassname="col-2 flex justify-center items-center gap-1"
                                    label=''
                                    disabled={validateFeild.volumetricSelection !== '' && !formData.isVolSelection}
                                    onChange={(e) => {
                                        const value = e.target.value
                                        setFormData({ ...formData, volumetricSelection: value })
                                        getDivisorAndCft(value, loginUserClientCode, formData?.serviceMode)
                                    }}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtPartNo0'].focus()
                                        }
                                    }}
                                >
                                    <option value=''>-Select-</option>
                                    {getVolumertricSelection?.data?.dropDownData?.map((item, index) =>
                                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                                    )}
                                </SelectInputBox>
                            }
                            {formData.cft &&
                                <InputBox
                                    divclassname="col-2 flex justify-center items-center gap-1"
                                    label='CFT'
                                    disabled
                                    inputrefs={inputrefs}
                                    value={formData.cft}
                                />
                            }
                        </div>
                    </div>

                    {formData?.weightDetails?.length > 0 && (
                        <div className="mt-2 w-full overflow-x-auto">
                            <table className="w-full border border-gray-300">
                                {tableHeader}
                                {tableBody}
                            </table>
                        </div>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-5 mt-3 gap-3">
                        <InputBox
                            id="txtTotalWeight"
                            label="Total Actual Weight"
                            disabled
                            value={formData.totalWeight}
                            onChange={(e) =>
                                setFormData({ ...formData, totalWeight: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    inputrefs.current["txtTotalChargeWeight"]?.focus();
                                }
                            }}
                            placeholder="Enter Total Weight"
                        />
                        <InputBox
                            id="txtTotalVolumetricWeight"
                            label="Total Vol. Weight"
                            disabled
                            value={formData.totalVolumetricWeight}
                            onChange={(e) =>
                                setFormData({ ...formData, totalVolumetricWeight: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    inputrefs.current["txtPacketDescription"]?.focus();
                                }
                            }}
                            placeholder="Enter Charge Weight"
                        />
                        <InputBox
                            id="txtTotalChargeWeight"
                            label="Total Charge Weight"
                            disabled
                            value={formData.totalChargeWeight}
                            onChange={(e) =>
                                setFormData({ ...formData, totalChargeWeight: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    inputrefs.current["txtTotalVolumetricWeight"]?.focus();
                                }
                            }}
                            placeholder="Enter Charge Weight"
                        />
                        <InputBox
                            id="txtPacketDescription"
                            label="Packet Description"
                            value={formData.packetDescription}
                            onChange={(e) =>
                                setFormData({ ...formData, packetDescription: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    formData.paymentType === "COD" || formData.paymentType === "CASH" ?
                                        inputrefs.current['txtAmount'].focus() :
                                        inputrefs.current['txtPacketType'].focus();
                                }
                            }}
                            placeholder="Enter Packet Description"
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="bg-white shadow-sm rounded-xl p-3 border border-gray-200/80 hover:shadow-md transition-all duration-200">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mb-2.5 pb-1.5 border-b border-gray-100">
                    <div className="flex items-center gap-2">
                        <Weight className="w-4 h-4 text-red-500" />
                        <h3 className="text-xs font-bold text-gray-800 m-0">Weight & Dimension Details</h3>
                    </div>
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
                        <div className="flex items-center gap-1">
                            <span className="text-[10px] font-semibold text-gray-500 whitespace-nowrap">Total Pieces:</span>
                            <input
                                id="txtTotalPcs"
                                type="text"
                                ref={(ref) => { inputrefs.current["txtTotalPcs"] = ref }}
                                className="w-14 h-6 text-[11px] border border-gray-300 rounded text-center focus:outline-none focus:border-[var(--brand-accent)]"
                                maxLength="3"
                                value={formData.totalPcs}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setFormData({ ...formData, totalPcs: convertToNumber(value) });
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        if (formData.totalPcs === '') {
                                            NotificationSound('ERROR', 'Please Enter Total Pices.!')
                                            return
                                        }
                                        inputrefs.current["txtVolWeight"]?.focus();
                                    }
                                }}
                                placeholder="Pcs"
                            />
                        </div>
                        <div className="flex items-center gap-1.5">
                            <input
                                type="checkbox"
                                id="txtVolWeight"
                                ref={(ref) => { inputrefs.current["txtVolWeight"] = ref }}
                                className="w-3.5 h-3.5 text-red-600 border-gray-300 rounded focus:ring-red-500 cursor-pointer"
                                checked={formData.isVolWeight}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    setFormData(prev => ({
                                        ...prev,
                                        isVolWeight: checked,
                                        weightDetails: prev.weightDetails.map(row => ({
                                            ...row,
                                            length: checked ? row.length : "",
                                            width: checked ? row.width : "",
                                            height: checked ? row.height : "",
                                            volumetricWeight: checked ? row.volumetricWeight : ""
                                        }))
                                    }));
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        if (
                                            formData.isVolWeight &&
                                            !(validateFeild.volumetricSelection !== '' && !formData.isVolSelection)
                                        ) {
                                            inputrefs.current["txtVolumetricSelection"]?.focus();
                                        } else {
                                            inputrefs.current["txtPartNo0"]?.focus();
                                        }
                                    }
                                }}
                            />
                            <label htmlFor="txtVolWeight" className="text-[10px] font-semibold text-gray-500 cursor-pointer select-none">
                                Volumetric
                            </label>
                        </div>
                        {formData.isVolWeight && (
                            <div className="flex items-center gap-1">
                                <span className="text-[10px] font-semibold text-gray-500 whitespace-nowrap">Vol. Std:</span>
                                <select
                                    id="txtVolumetricSelection"
                                    ref={(ref) => { inputrefs.current["txtVolumetricSelection"] = ref }}
                                    className="w-24 h-6 text-[11px] border border-gray-300 rounded px-1 focus:outline-none focus:border-[var(--brand-accent)]"
                                    value={formData.volumetricSelection}
                                    disabled={validateFeild.volumetricSelection !== '' && !formData.isVolSelection}
                                    onChange={(e) => {
                                        const value = e.target.value
                                        setFormData({ ...formData, volumetricSelection: value })
                                        getDivisorAndCft(value, loginUserClientCode, formData?.serviceMode)
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtPartNo0'].focus()
                                        }
                                    }}
                                >
                                    <option value=''>-Select-</option>
                                    {getVolumertricSelection?.data?.dropDownData?.map((item, index) =>
                                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                                    )}
                                </select>
                            </div>
                        )}
                        {formData.cft && (
                            <div className="flex items-center gap-1">
                                <span className="text-[10px] font-semibold text-gray-500 whitespace-nowrap">CFT:</span>
                                <input
                                    type="text"
                                    className="w-10 h-6 text-[11px] border border-gray-300 bg-gray-50 rounded text-center outline-none"
                                    disabled
                                    value={formData.cft}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {formData?.weightDetails?.length > 0 && (
                    <div className="w-full overflow-x-auto rounded-lg border border-slate-200 mb-4">
                        <table className="w-full border-collapse text-left text-xs text-slate-600">
                            {tableHeader}
                            {tableBody}
                        </table>
                    </div>
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2 bg-slate-50 p-2.5 rounded-xl border border-slate-100">
                    <InputBox
                        id="txtTotalWeight"
                        label="Total Actual Weight"
                        disabled
                        value={formData.totalWeight}
                        onChange={(e) =>
                            setFormData({ ...formData, totalWeight: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtTotalChargeWeight"]?.focus();
                            }
                        }}
                        placeholder="Total Weight"
                    />
                    <InputBox
                        id="txtTotalVolumetricWeight"
                        label="Total Vol. Weight"
                        disabled
                        value={formData.totalVolumetricWeight}
                        onChange={(e) =>
                            setFormData({ ...formData, totalVolumetricWeight: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtPacketDescription"]?.focus();
                            }
                        }}
                        placeholder="Vol. Weight"
                    />
                    <InputBox
                        id="txtTotalChargeWeight"
                        label="Total Charge Weight"
                        disabled
                        value={formData.totalChargeWeight}
                        onChange={(e) =>
                            setFormData({ ...formData, totalChargeWeight: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtTotalVolumetricWeight"]?.focus();
                            }
                        }}
                        placeholder="Charge Weight"
                    />
                    <InputBox
                        id="txtPacketDescription"
                        label="Packet Description"
                        value={formData.packetDescription}
                        onChange={(e) =>
                            setFormData({ ...formData, packetDescription: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                formData.paymentType === "COD" || formData.paymentType === "CASH" ?
                                    inputrefs.current['txtAmount'].focus() :
                                    inputrefs.current['txtPacketType'].focus();
                            }
                        }}
                        placeholder="Packet Description"
                    />
                </div>
            </div>
        );
    };

    const renderPaymentDetails = (isAdvanced) => {
        const body = (
            <>
                <SelectInputBox
                    id="txtPaymentType"
                    value={formData.paymentType}
                    label='Payment Type'
                    disabled={!ispayment}
                    required={true}
                    onChange={(e) => setFormData({ ...formData, paymentType: e.target.value })}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            formData.paymentType === "COD" || formData.paymentType === "CASH" ?
                                inputrefs.current['txtAmount'].focus() :
                                inputrefs.current['txtPacketType'].focus();
                        }
                    }}
                >
                    <option value=''>--Please Select--</option>
                    {GetPaymentType?.data?.dropDownData?.map((item, index) =>
                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                    )}
                </SelectInputBox>

                {(formData.paymentType === "COD" || formData.paymentType === "CASH") && (
                    <InputBox
                        id="txtAmount"
                        label="Amount"
                        placeholder="Enter Amount"
                        maxLength='10'
                        required
                        value={formData.amount}
                        onChange={(e) =>
                            setFormData({ ...formData, amount: convertThreeDecimalsWithoutZero(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtPacketType']?.focus();
                            }
                        }}
                    />
                )}

                <SelectInputBox
                    id="txtPacketType"
                    value={formData.packetType}
                    label='Packet Type'
                    required={true}
                    onChange={(e) => setFormData({ ...formData, packetType: e.target.value })}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            inputrefs.current['txtServiceType'].focus()
                        }
                    }}
                >
                    <option value=''>--Please Select--</option>
                    {GetPacketType?.data?.dropDownData?.map((item, index) =>
                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                    )}
                </SelectInputBox>

                <SelectInputBox
                    id="txtServiceType"
                    value={formData.serviceType}
                    label='Service Type'
                    required={true}
                    onChange={(e) => setFormData({ ...formData, serviceType: e.target.value })}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            inputrefs.current['txtShipmentType'].focus()
                        }
                    }}
                >
                    <option value=''>--Please Select--</option>
                    {GetServiceType?.data?.dropDownData?.map((item, index) =>
                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                    )}
                </SelectInputBox>

                <SelectInputBox
                    id="txtShipmentType"
                    value={formData.shipmentType}
                    label='Shipment Type'
                    required={true}
                    onChange={(e) => setFormData({ ...formData, shipmentType: e.target.value, codAmount: "" })}
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            formData.shipmentType === "COD" ?
                                inputrefs.current['txtCODAmount'].focus() :
                                inputrefs.current['txtRemarks'].focus();
                        }
                    }}
                >
                    <option value=''>--Please Select--</option>
                    {GetShipmentType?.data?.dropDownData?.map((item, index) =>
                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                    )}
                </SelectInputBox>

                {formData.shipmentType === "COD" && (
                    <InputBox
                        id="txtCODAmount"
                        label="COD Amount"
                        placeholder="Enter COD Amount"
                        maxLength='10'
                        value={formData.codAmount}
                        onChange={(e) =>
                            setFormData({ ...formData, codAmount: convertTwoDecimalsOnValue(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtRemarks']?.focus();
                            }
                        }}
                        required
                    />
                )}

                <InputBox
                    id="txtRemarks"
                    label="Remarks"
                    placeholder="Enter Remarks"
                    value={formData.remarks}
                    onChange={(e) =>
                        setFormData({ ...formData, remarks: e.target.value })
                    }
                    inputrefs={inputrefs}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            inputrefs.current['txtInvoiceNo']?.focus();
                        }
                    }}
                />
            </>
        );

        if (!isAdvanced) {
            return (
                <div className="mt-3 card-body shadow-lg rounded-md border-t-4 border-yellow-500 p-3 pt-2 bg-white">
                    <div className="flex mb-2 items-center gap-2">
                        <WalletCards size={18} className="text-yellow-600" />
                        <div>
                            <h2 className="text-base font-semibold text-gray-800">
                                Payment Details
                            </h2>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
                        {body}
                    </div>
                </div>
            );
        }

        return (
            <div className="bg-white shadow-sm rounded-xl p-3 border border-gray-200/80 hover:shadow-md transition-all duration-200">
                <div className="flex items-center gap-2 mb-2 pb-1.5 border-b border-gray-100">
                    <WalletCards className="w-4 h-4 text-yellow-500" />
                    <h3 className="text-xs font-bold text-gray-800 m-0">Payment & Billing Details</h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2">
                    {body}
                </div>
            </div>
        );
    };

    const renderInvoiceDetails = (isAdvanced) => {
        const body = (
            <>
                <div className="row">
                    <InputBox
                        divclassname="col-md-2"
                        id="txtInvoiceNo"
                        label="Invoice No"
                        value={packetDetail.invoiceNo}
                        onChange={(e) =>
                            setPacketDetail({ ...packetDetail, invoiceNo: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtInvoiceDate"]?.focus();
                            }
                        }}
                        maxLength='16'
                        placeholder="Enter Invoice No"
                    />

                    <DateBox
                        divclassname="col-md-2"
                        id="txtInvoiceDate"
                        label="Invoice Date"
                        maxDate={new Date()}
                        placeholder="DD-MM-YYYY"
                        value={packetDetail.invoiceDate}
                        inputrefs={inputrefs}
                        selected={
                            packetDetail?.invoiceDate
                                ? new Date(packetDetail.invoiceDate)
                                : null
                        }
                        onChange={(date) =>
                            handleDateChange(date, setPacketDetail, packetDetail, 'invoiceDate')
                        }
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtInvoiceValue']?.focus()
                            }
                        }}
                    />

                    <InputBox
                        divclassname="col-md-4"
                        id="txtInvoiceValue"
                        label="Invoice Value"
                        value={packetDetail.invoiceValue}
                        onChange={(e) =>
                            setPacketDetail({ ...packetDetail, invoiceValue: convertTwoDecimalsOnValue(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtEWayBillNo"]?.focus();
                            }
                        }}
                        maxLength='18'
                        placeholder="Enter Invoice Value"
                    />

                    <InputBox
                        divclassname="col-md-2"
                        id="txtEWayBillNo"
                        label="E-Way Bill No"
                        maxLength='12'
                        value={packetDetail.ewayBillNo}
                        onChange={(e) =>
                            setPacketDetail({ ...packetDetail, ewayBillNo: convertToNumber(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtEWayBillExpDate"]?.focus();
                            }
                        }}
                        placeholder="Enter EWay Bill No"
                    />

                    <DateBox
                        divclassname="col-md-2"
                        id="txtEWayBillExpDate"
                        label="E-Way Bill Exp Date"
                        minDate={new Date()}
                        value={packetDetail.ewayBillExpDate}
                        inputrefs={inputrefs}
                        selected={
                            packetDetail?.ewayBillExpDate
                                ? new Date(packetDetail.ewayBillExpDate)
                                : null
                        }
                        onChange={(date) =>
                            handleDateChange(date, setPacketDetail, packetDetail, 'ewayBillExpDate')
                        }
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['btnSaveContact']?.focus()
                            }
                        }}
                    />

                    <div className="flex gap-2 col-md-2 mt-2">
                        <button
                            type="button"
                            id="btnSaveContact"
                            ref={ref => (inputrefs.current["btnSaveContact"] = ref)}
                            onClick={handleAddInvoice}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['btnSub']?.focus()
                                }
                            }}
                            className="bg-cyan-500 hover:bg-cyan-600 text-white w-7 h-7 mt-3 rounded-lg inline-flex items-center justify-center transition-colors shadow-sm border-0"
                            title="Add Invoice"
                        >
                            <i className="fa-solid fa-plus"></i>
                        </button>

                        <button
                            type="button"
                            onClick={handleClearInvoice}
                            className="bg-slate-500 hover:bg-slate-600 text-white w-7 h-7 mt-3 rounded-lg inline-flex items-center justify-center transition-colors shadow-sm border-0"
                            title="Reset Fields"
                        >
                            <i className="fa-solid fa-arrow-rotate-left"></i>
                        </button>
                    </div>
                </div>

                {formData?.invoiceDetails?.length > 0 && (
                    <div className="w-full overflow-x-auto rounded-lg border border-slate-200 mt-4 shadow-sm">
                        <table className="w-full border-collapse text-left text-xs text-slate-600">
                            <thead className={isAdvanced ? "bg-slate-50 text-slate-700 text-xs uppercase tracking-wider font-semibold border-b border-slate-200" : "bg-gray-100 text-sm border-b"}>
                                <tr>
                                    <th className="border p-2.5">Invoice No</th>
                                    <th className="border p-2.5">Date</th>
                                    <th className="border p-2.5">Value</th>
                                    <th className="border p-2.5">E-Way Bill No</th>
                                    <th className="border p-2.5">E-Way Bill Exp Date</th>
                                    <th className="border p-2.5">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formData.invoiceDetails.map((item, index) => (
                                    <tr key={index} className={isAdvanced ? "hover:bg-slate-50/50 transition-colors border-b" : "border-b"}>
                                        <td className="border p-2.5">{item.invoiceNo}</td>
                                        <td className="border p-2.5">{item.invoiceDate}</td>
                                        <td className="border p-2.5">{item.invoiceValue}</td>
                                        <td className="border p-2.5">{item.ewayBillNo}</td>
                                        <td className="border p-2.5">{item.ewayBillExpDate}</td>
                                        <td className="border p-2.5 text-center">
                                            <i
                                                className="fa-regular fa-trash-can text-red-500 hover:text-red-700 cursor-pointer text-sm transition-colors"
                                                onClick={() => handleDeleteInvoice(index)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </>
        );

        if (!isAdvanced) {
            return (
                <div className="mt-3 card-body shadow-lg rounded-md border-t-4 border-orange-500 p-3 pt-2 bg-white">
                    <div className="flex mb-2 items-center gap-2">
                        <Receipt size={18} className="text-orange-600" />
                        <div>
                            <h2 className="text-base font-semibold text-gray-800">
                                Ewaybill/Invoice Details
                            </h2>
                        </div>
                    </div>
                    {body}
                    <div className='card-body mt-2'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            Export={false}
                            handleSubmit={handleSubmit}
                            handleClear={handleClear}
                            isPrint={false}
                            PrintText={'Docket Print'}
                            handlePrint={handlePrint}
                            SeeAndPrint={!!awbNoForPrint}
                            handleSeeAndPrint={handleSeeAndPrint}
                            LabelPrint={!!awbNoForPrint}
                            handleLabelPrint={handleLabelPrint}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="bg-white shadow-sm rounded-xl p-3 border border-gray-200/80 hover:shadow-md transition-all duration-200">
                <div className="flex items-center gap-2 mb-2 pb-1.5 border-b border-gray-100">
                    <Receipt className="w-4 h-4 text-orange-500" />
                    <h3 className="text-xs font-bold text-gray-800 m-0">Ewaybill & Invoice Details</h3>
                </div>
                {body}
            </div>
        );
    };

    const renderSidebarSummary = () => {
        return (
            <div className="sticky top-20 bg-white text-gray-800 rounded-2xl p-3 shadow-md border border-gray-200/85 flex flex-col gap-2.5">
                <div className="flex items-center justify-between pb-1.5 border-b border-gray-100">
                    <div className="flex items-center gap-1.5">
                        <Receipt className="w-4 h-4 text-indigo-600" />
                        <span className="text-[11px] font-extrabold tracking-wider uppercase text-gray-700">Docket Summary</span>
                    </div>
                    <span className="text-[9px] bg-indigo-50 text-indigo-600 font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider">Live</span>
                </div>

                <div className="flex flex-col gap-1 text-[11px]">
                    <div className="flex justify-between">
                        <span className="text-gray-400">Docket No:</span>
                        <span className="font-bold text-gray-800">
                            {formData.awbNo || <span className="text-gray-400 italic font-normal">[Auto]</span>}
                        </span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-400">Client:</span>
                        <span className="font-semibold text-gray-800 truncate max-w-[140px]" title={loginUserClientCode}>
                            {loginUserClientCode || <span className="text-gray-400 italic font-normal">--</span>}
                        </span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-400">Booking:</span>
                        <span className="font-semibold text-gray-800">{formData.bookingType || "--"}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-400">Mode:</span>
                        <span className="font-semibold text-gray-800">{formData.serviceMode || "--"}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-400">Date:</span>
                        <span className="font-semibold text-gray-800">{formData.pickupDate || "--"}</span>
                    </div>
                </div>

                <div className="flex flex-col gap-2 text-[11px]">
                    <div>
                        <span className="text-[9px] uppercase font-bold text-green-600 block mb-0.5 tracking-wider">From (Consignor)</span>
                        <div className="bg-green-50/40 p-1.5 rounded-lg border border-green-100/60">
                            <div className="font-bold text-gray-800 truncate text-[11px]">{formData.consignorName || <span className="text-gray-400 italic font-normal">Not set</span>}</div>
                            {formData.consignorCity && (
                                <div className="text-[9px] text-gray-500 mt-0.5">
                                    {formData.consignorCity}, {formData.consignorState} {formData.consignorPinCode && `(${formData.consignorPinCode})`}
                                </div>
                            )}
                        </div>
                    </div>
                    <div>
                        <span className="text-[9px] uppercase font-bold text-blue-600 block mb-0.5 tracking-wider">To (Consignee)</span>
                        <div className="bg-blue-50/40 p-1.5 rounded-lg border border-blue-100/60">
                            <div className="font-bold text-gray-800 truncate text-[11px]">{formData.consigneeName || <span className="text-gray-400 italic font-normal">Not set</span>}</div>
                            {formData.consigneeCity && (
                                <div className="text-[9px] text-gray-500 mt-0.5">
                                    {formData.consigneeCity}, {formData.consigneeState} {formData.consigneePinCode && `(${formData.consigneePinCode})`}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="bg-slate-50/80 p-2 rounded-xl border border-gray-150 flex flex-col gap-1 text-[11px]">
                    <div className="flex justify-between">
                        <span className="text-gray-500">Total Pieces:</span>
                        <span className="font-bold text-gray-850">{formData.totalPcs || "0"} pcs</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-500">Actual Weight:</span>
                        <span className="font-bold text-gray-850">{formData.totalWeight || "0.000"} kg</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-500">Vol. Weight:</span>
                        <span className="font-bold text-gray-850">{formData.totalVolumetricWeight || "0.000"} kg</span>
                    </div>
                    <div className="flex justify-between pt-1 border-t border-gray-200 text-xs font-extrabold text-indigo-600">
                        <span>Charge Weight:</span>
                        <span>{formData.totalChargeWeight || "0.000"} kg</span>
                    </div>
                </div>

                <div className="flex flex-col gap-1 text-[11px] text-gray-600 px-0.5">
                    <div className="flex justify-between">
                        <span>Payment Type:</span>
                        <span className="font-semibold text-gray-800">{formData.paymentType || "--"}</span>
                    </div>
                    {formData.amount && (
                        <div className="flex justify-between">
                            <span>Amount:</span>
                            <span className="font-extrabold text-indigo-600">?{formData.amount}</span>
                        </div>
                    )}
                    {formData.shipmentType === "COD" && formData.codAmount && (
                        <div className="flex justify-between">
                            <span>COD Amount:</span>
                            <span className="font-extrabold text-red-500">?{formData.codAmount}</span>
                        </div>
                    )}
                    <div className="flex justify-between">
                        <span>Invoices:</span>
                        <span className="font-semibold text-gray-800">
                            {formData.invoiceDetails.length > 0 ? (
                                `${formData.invoiceDetails.length} Invoice(s)`
                            ) : (
                                "None"
                            )}
                        </span>
                    </div>
                </div>

                <div className="pt-2 border-t border-gray-100">
                    <FormButton
                        id={'btnSub'}
                        inputrefs={inputrefs}
                        Export={false}
                        handleSubmit={handleSubmit}
                        handleClear={handleClear}
                        isPrint={false}
                        PrintText={'Docket Print'}
                        handlePrint={handlePrint}
                        SeeAndPrint={!!awbNoForPrint}
                        handleSeeAndPrint={handleSeeAndPrint}
                        LabelPrint={!!awbNoForPrint}
                        handleLabelPrint={handleLabelPrint}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className="min-h-screen bg-slate-50/50 p-2 sm:p-4">
            {renderTopToolbar()}

            {!isAdvanceLayout ?
                (<>
                    <div className="bg-secondary-50 shadow-md rounded-md p-3 pt-1 border-t-4 border-orange-400">
                        <div className="flex mb-2 items-center justify-between">
                            {renderClassicHeader()}
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-6 gap-2">
                            {renderGeneralDetails(false)}
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        {renderConsignorDetails(false)}
                        {renderConsigneeDetails(false)}
                    </div>
                    {renderWeightDetails(false)}
                    {renderPaymentDetails(false)}
                    {renderInvoiceDetails(false)}

                </>
                ) : (
                    <div className="grid grid-cols-1 xl:grid-cols-12 gap-3">
                        <div className="xl:col-span-9 flex flex-col gap-3">
                            {renderGeneralDetails(true)}
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
                                {renderConsignorDetails(true)}
                                {renderConsigneeDetails(true)}
                            </div>
                            {renderWeightDetails(true)}
                            {renderPaymentDetails(true)}
                            {renderInvoiceDetails(true)}
                        </div>
                        <div className="xl:col-span-3">
                            {renderSidebarSummary()}
                        </div>
                    </div>
                )}
        </div>
    );
}

export default Shipment;